export default __webpack_public_path__ + "static/media/favorite_preparation.6b1c6b3b.jpg";